export const LANGUAGE_PICKER_POSITION = ['top', 'bottom'] as const;
